<template>
	<div class="flex">
		<svg v-for="s, i in Array.from({length: 5})" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.52447 1.46353C9.67415 1.00287 10.3259 1.00287 10.4755 1.46353L12.1329 6.56434C12.1998 6.77035
                    12.3918 6.90983 12.6084 6.90983H17.9717C18.4561 6.90983 18.6575 7.52964 18.2656 7.81434L13.9266
                    10.9668C13.7514 11.0941 13.678 11.3198 13.745 11.5258L15.4023 16.6266C15.552 17.0873 15.0248 17.4704
                    14.6329 17.1857L10.2939 14.0332C10.1186 13.9059 9.88135 13.9059 9.70611 14.0332L5.3671 17.1857C4.97524
                    17.4704 4.448 17.0873 4.59768 16.6266L6.25503 11.5258C6.32197 11.3198 6.24864 11.0941 6.07339 10.9668L1.73438
                    7.81434C1.34253 7.52964 1.54392 6.90983 2.02828 6.90983H7.39159C7.6082 6.90983 7.80018 6.77035 7.86712
                    6.56434L9.52447 1.46353Z"
				:fill="i+1 <= roundedStars ? 'rgba(229,151,137,1)' : '#ECEEF5'"
			></path>
			<path
                v-if="i+1 > roundedStars && roundedStars > i+1-0.75"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10 1.125C9.79968 1.125 9.59934 1.24016 9.5245 1.47049L7.86714 6.5713C7.80021 6.77732 7.60823 6.9168
                    7.39161 6.9168H2.0283C1.54394 6.9168 1.34255 7.5366 1.73441 7.8213L6.07342 10.9738C6.24866 11.1011
                    6.32199 11.3268 6.25506 11.5328L4.5977 16.6336C4.44803 17.0943 4.97527 17.4773 5.36712 17.1926L9.70613
                    14.0402C9.79375 13.9765 9.89689 13.9447 10 13.9447V1.125Z"
				fill="rgba(229,151,137,1)"
			></path>
		</svg>
	</div>
</template>

<script>
export default {
    props: ['stars'],
    computed: {
        roundedStars() {
            return Math.round(this.stars * 2) / 2;
        }
    }
}
</script>
